module.exports = __webpack_public_path__ + "img/vip-card-flag.ae882d08.png";